import React, { useContext, useState } from 'react';
import { CaretRightOutlined } from '@ant-design/icons';
import { Button, Col, Collapse, Form, Input, Radio, Row, Space, Select } from 'antd';
import PropTypes from 'prop-types';
import FatcaModal from '../../../../../EnrollmentPage/components/steps/ComplementaryInfoStep/FatcaModal';
import CollapseForm from './components/CollapseForm';
import LeaderFormList from './components/LeaderFormList';
import TaxResidenceModal from '../../../../../EnrollmentPage/components/steps/ComplementaryInfoStep/TaxResidenceModal';
import TaxResidenceForm from './components/TaxResidenceForm';
import './styles.less';
import { EnrollmentFormContext } from '../../../../../../providers/EnrollmentFormContextProvider';
import useParams from '../../../../../params/useParams';
import paramEndpoints from '../../../../../params/paramEndpoints';
import form from '../../../../../../utils/form';
import DeliverableType from '../../../../../../enums/DeliverableType';
import tokens from '../../../../../../utils/tokens';
import DrawerQualifiedProfile from './components/DrawerQualifiedProfile';
import DrawerInstitutionalProfile from './components/DrawerInstitucionalProfile';
import DecretoModal from '../../../../../EnrollmentPage/components/steps/ComplementaryInfoStep/DecretoModal';

const FormComplementaryInfo = ({ onFinish }) => {
  const { enrollmentForm } = useContext(EnrollmentFormContext);
  const [informationDestinations] = useParams(paramEndpoints.INFORMATION_DESTINATIONS);
  const [instructionTypes] = useParams(paramEndpoints.INSTRUCTION_TYPES);

  const [relations, areRelationsLoading] = useParams(paramEndpoints.VANTRUST_RELATIONS);
  const [selectedRelation, setSelectedRelation] = useState(false);
  const [visible, setVisible] = useState(false);
  const [institutionalDrawerVisible, setInstitutionalDrawerVisible] = useState(false);
  const [qualifiedInvestor, setQualifiedInvestor] = useState(false);
  const [savedQualifiedInvestor, setSavedQualifiedInvestor] = useState(false);
  const [showValidationMessages, setShowValidationMessages] = useState(false);
  const [institutionalInfoForm] = Form.useForm();
  const [qualifiedInfoForm] = Form.useForm();
  const { Panel } = Collapse;
  const toggleRadioRelation = () => {
    setSelectedRelation(true);
  };

  const onChangeRadioQualified = (e) => {
    if (e.target.value) {
      setVisible(true);
      setQualifiedInvestor(true);
    } else {
      setQualifiedInvestor(false);
      setSavedQualifiedInvestor(false);
    }
  };
  const onChangeRadioInstitutional = (e) => {
    if (e.target.value) {
      setInstitutionalDrawerVisible(true);
    }
  };
  const toggleRadioRelationFalse = () => {
    setSelectedRelation(false);
  };

  const handleSubmit = () => {
    if (qualifiedInvestor && !savedQualifiedInvestor) {
      setShowValidationMessages(true);
      setVisible(true);
      return;
    }

    enrollmentForm.validateFields().then(() => {
      const visibleFormValues = enrollmentForm.getFieldsValue();
      const allFormValues = enrollmentForm.getFieldsValue();

      const objKeys = Object.keys(visibleFormValues).filter((key) => Number(key) >= 0);

      const authorizedToGiveInstruction = objKeys.map((element) => ({
        ...visibleFormValues[element],
      }));

      const payload = {
        ...visibleFormValues,
        deliverablesDestinataries:
          visibleFormValues.clientInfoDestinyId === 2
            ? allFormValues.deliverablesDestinataries
            : undefined,
        clientInfoDestinyId:
          visibleFormValues.clientInfoDestinyId === 'OTRO'
            ? 3
            : visibleFormValues.clientInfoDestinyId,

        authorizedToGiveInstructions: authorizedToGiveInstruction,
      };

      onFinish(payload);
    });
  };

  return (
    <Row className="formComplementaryInfo">
      <Col span={24}>
        <Form
          form={enrollmentForm}
          validateMessages={form.validateMessages}
          onFinish={onFinish}
          layout="vertical"
        >
          <Row>
            <Col lg={15} xs={24}>
              <Form.Item
                name="hasVantrustRelation"
                label="¿Tiene alguna relación con VanTrust o sus empleados?"
                rules={[{ required: true, message: 'Dato requerido' }]}
              >
                <Radio.Group>
                  <Radio value onChange={toggleRadioRelation}>
                    Si
                  </Radio>
                  <Radio value={false} onChange={toggleRadioRelationFalse}>
                    No
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          {selectedRelation ? (
            <Row gutter={tokens.forms.horizontalGutterInPx}>
              <Col lg={12} xs={24}>
                <Form.Item
                  name="vantrustRelation"
                  label="Seleccionar cargo"
                  rules={[
                    {
                      required: true,
                      message: 'Dato requerido',
                    },
                  ]}
                >
                  <Select loading={areRelationsLoading} disabled={areRelationsLoading}>
                    {relations.map((relation) => (
                      <Select.Option key={relation.name} value={relation.id}>
                        {relation.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col lg={12} xs={24}>
                <Form.Item shouldUpdate noStyle>
                  {() =>
                    enrollmentForm.getFieldValue(['vantrustRelation']) === '(7) OTRAS-PERSONAS' && (
                      <Form.Item
                        name="otherVantrustRelation"
                        label={' '}
                        rules={[
                          {
                            required: true,
                            message: 'Dato requerido',
                          },
                        ]}
                        required={false}
                      >
                        <Input placeholder="especifique" />
                      </Form.Item>
                    )
                  }
                </Form.Item>
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col className="formComplementaryInfo__title">Comunicaciones y Órdenes</Col>
          </Row>
          <Row>
            <Col span={23}>
              <Form.Item
                name="instructionType"
                label="Tipos de Instrucción"
                rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Space direction="vertical">
                    {instructionTypes.map((instructionType) => (
                      <Radio key={instructionType.id} value={instructionType.id}>
                        {instructionType.name}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg={18} xs={23}>
              <Form.Item
                name="clientInfoDestinyId"
                label="Destino de Información al Cliente"
                rules={[{ required: true }]}
              >
                <Radio.Group>
                  <Space direction="vertical">
                    {informationDestinations.map((informationDestination) => (
                      <Radio key={informationDestination.id} value={informationDestination.id}>
                        {informationDestination.name}
                      </Radio>
                    ))}
                    <Form.Item shouldUpdate noStyle>
                      {() => (
                        <>
                          {enrollmentForm.getFieldValue('clientInfoDestinyId') === 'OTRO' && (
                            <Form.Item
                              name="clientInfoDestinyEmail"
                              noStyle
                              rules={[{ required: true }]}
                            >
                              <Input placeholder="Correo electrónico" maxLength={128} />
                            </Form.Item>
                          )}
                          {enrollmentForm.getFieldValue('clientInfoDestinyId') === 2 && (
                            <>
                              <Collapse
                                ghost
                                className="formComplementaryInfo__collapse"
                                expandIcon={({ isActive }) => (
                                  <CaretRightOutlined rotate={isActive ? 90 : 0} />
                                )}
                              >
                                <Panel
                                  header="Envío de Cartola adicionalmente del correo de cliente"
                                  key="1"
                                >
                                  <CollapseForm
                                    deliverableType={DeliverableType.AccountStatement}
                                  />
                                </Panel>
                              </Collapse>
                              <Collapse
                                ghost
                                className="formComplementaryInfo__collapse"
                                expandIcon={({ isActive }) => (
                                  <CaretRightOutlined rotate={isActive ? 90 : 0} />
                                )}
                              >
                                <Panel header="Envío de Swift" key="2">
                                  <CollapseForm deliverableType={DeliverableType.Swift} />
                                </Panel>
                              </Collapse>
                              <Collapse
                                ghost
                                className="formComplementaryInfo__collapse"
                                expandIcon={({ isActive }) => (
                                  <CaretRightOutlined rotate={isActive ? 90 : 0} />
                                )}
                              >
                                <Panel header="Envío de Factura" key="3">
                                  <CollapseForm deliverableType={DeliverableType.Invoice} />
                                </Panel>
                              </Collapse>
                            </>
                          )}
                        </>
                      )}
                    </Form.Item>
                  </Space>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col className="formComplementaryInfo__text">
              Personas autorizadas para dar instrucciones
            </Col>
          </Row>
          <LeaderFormList />
          <Row>
            <Col lg={19} xs={23}>
              <Form.Item
                label="¿Autoriza la reinversión de los beneficios repartidos en cuotas del Fondo o de la serie respectiva? (Sólo para Administradora General de Fondos SA y Gestión Patrimonial SA)"
                name={['authorizeReinvestment']}
                rules={[{ required: true }]}
              >
                <Radio.Group
                  options={[
                    { label: 'Si', value: true },
                    { label: 'No', value: false },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg={19} xs={23}>
              <Form.Item
                label="¿Eres un inversionista calificado?"
                name={['enrollmentInvestorProfile', 'isQualifiedInvestor']}
                rules={[{ required: true }]}
              >
                <Radio.Group
                  options={[
                    { label: 'Si', value: true },
                    { label: 'No', value: false },
                  ]}
                  onChange={onChangeRadioQualified}
                />
              </Form.Item>
              <DrawerQualifiedProfile
                visible={visible}
                closeDrawer={() => setVisible(false)}
                form={qualifiedInfoForm}
                qualifiedInvestor={qualifiedInvestor}
                setSavedQualifiedInvestor={setSavedQualifiedInvestor}
                showValidationMessages={showValidationMessages}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={19} xs={23}>
              <Form.Item
                label="¿Eres un inversionista institucional?"
                name={['enrollmentInvestorProfile', 'isInstitutionalInvestor']}
                rules={[{ required: true }]}
              >
                <Radio.Group
                  options={[
                    { label: 'Si', value: true },
                    { label: 'No', value: false },
                  ]}
                  onChange={onChangeRadioInstitutional}
                />
              </Form.Item>

              <DrawerInstitutionalProfile
                visible={institutionalDrawerVisible}
                closeDrawer={() => setInstitutionalDrawerVisible(false)}
                form={institutionalInfoForm}
              />
            </Col>
          </Row>
          <Form.Item label="¿Eres ciudadano/residente de E.E.U.U?" required>
            <FatcaModal />
            <Form.Item
              name={['mainLegalRepresentative', 'isUsPerson']}
              rules={[{ required: true }]}
              noStyle
            >
              <Radio.Group
                options={[
                  { label: 'Si', value: true },
                  { label: 'No', value: false },
                ]}
              />
            </Form.Item>
          </Form.Item>
          <Form.Item shouldUpdate noStyle>
            {() =>
              enrollmentForm.getFieldValue(['mainLegalRepresentative', 'isUsPerson']) && (
                <Row>
                  <Col lg={11} xs={23}>
                    <Form.Item
                      label="Ingresar número NIF"
                      name={['mainLegalRepresentative', 'nif']}
                      rules={[{ required: true }]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              )
            }
          </Form.Item>

          <Row>
            <Col lg={19} xs={23}>
              <Form.Item
                label="¿Es su representada una Institución Financiera en los términos definidos por el Decreto Nº 418?"
                required
              >
                <div className="formComplementaryInfo__info">
                  <DecretoModal />
                </div>
                <Form.Item
                  name={['legalPerson', 'isFinancialInstitution']}
                  rules={[{ required: true }]}
                  noStyle
                >
                  <Radio.Group
                    options={[
                      { label: 'Si', value: true },
                      { label: 'No', value: false },
                    ]}
                  />
                </Form.Item>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col lg={19} xs={23}>
              <Form.Item
                label="¿Tienes Residencia Tributaria distinta o adicional a la chilena?"
                name={['mainLegalRepresentative', 'hasForeignTaxResidences']}
                rules={[{ required: true }]}
              >
                <Radio.Group
                  options={[
                    { label: 'Si', value: true },
                    { label: 'No', value: false },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <TaxResidenceModal />
          <TaxResidenceForm taxForm={enrollmentForm} />
          <Row>
            <Col lg={11} xs={24}>
              <Form.Item>
                <Button type="primary" onClick={handleSubmit}>
                  Continuar
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  );
};

FormComplementaryInfo.propTypes = {
  onFinish: PropTypes.func.isRequired,
};

export default FormComplementaryInfo;
